var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcCabSettingsStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#36F6FF",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9985 8.5C19.237 8.49974 19.4695 8.5753 19.6622 8.71578C19.855 8.85625 19.9982 9.05436 20.071 9.2815L25 24.685L26.929 18.658C27.0015 18.4308 27.1443 18.2326 27.3368 18.0918C27.5293 17.9511 27.7615 17.8752 28 17.875H29.875C30.1734 17.875 30.4595 17.9935 30.6705 18.2045C30.8815 18.4155 31 18.7016 31 19C31 19.2984 30.8815 19.5845 30.6705 19.7955C30.4595 20.0065 30.1734 20.125 29.875 20.125H28.8205L26.071 28.7185C25.9981 28.9452 25.8551 29.143 25.6627 29.2833C25.4702 29.4236 25.2382 29.4991 25 29.4991C24.7618 29.4991 24.5298 29.4236 24.3373 29.2833C24.1449 29.143 24.0019 28.9452 23.929 28.7185L19.0075 13.339L15.5725 24.214C15.5016 24.4381 15.3624 24.6344 15.1742 24.7753C14.9861 24.9161 14.7586 24.9946 14.5236 24.9995C14.2886 25.0045 14.058 24.9357 13.8641 24.8029C13.6702 24.6701 13.5228 24.4799 13.4425 24.259L11.5465 19.045L11.4415 19.357C11.3669 19.5809 11.2238 19.7757 11.0324 19.9138C10.841 20.0519 10.611 20.1263 10.375 20.1265H8.125C7.82663 20.1265 7.54048 20.008 7.3295 19.797C7.11853 19.586 7 19.2999 7 19.0015C7 18.7031 7.11853 18.417 7.3295 18.206C7.54048 17.995 7.82663 17.8765 8.125 17.8765H9.565L10.432 15.271C10.5055 15.0491 10.6463 14.8556 10.8349 14.7174C11.0234 14.5791 11.2503 14.5031 11.4841 14.4998C11.7178 14.4965 11.9468 14.5661 12.1392 14.6989C12.3316 14.8318 12.4778 15.0212 12.5575 15.241L14.425 20.3785L17.9275 9.2875C17.9992 9.05949 18.1417 8.86024 18.3342 8.71864C18.5268 8.57705 18.7595 8.50046 18.9985 8.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcCabSettingsStatusIcon);
export default __webpack_public_path__ + "static/media/tc_cab_settings_status_icon.bec5a78566937bef847c9b4f47c2ea4c.svg";
export { ForwardRef as ReactComponent };